export const enum ScreenWidth {
    Desktop = 1280,
    Tablet = 768,
    Mobile = 0,
}
